<template>
  <div class="main" v-loading="loading">
    <div>
      <el-button class="screen" @click="is_dio = true">筛选</el-button>
      <el-table :data="data_list">
        <el-table-column prop="contact_name" label="联系人姓名" width="180">
        </el-table-column>
        <el-table-column label="零工账号类型" width="120">
          <template slot-scope="scope">
            <el-tag :type="scope.row.odd_job_status == 0 ? '' : ( scope.row.odd_job_status == 1 ? 'success' : 'warning' ) ">
              {{ scope.row.odd_job_status == 0 ? '餐饮兼职' : ( scope.row.odd_job_status == 1 ? '家政服务' : '学习辅导' ) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="username" label="登录账号" width="120">
        </el-table-column>
        <el-table-column prop="license_company_name" label="公司名/姓名" width="140">
        </el-table-column>
        <el-table-column
          prop="company_short_name"
          label="店铺名/品牌名/公司简称"
          width="180"
        >
        </el-table-column>
        <el-table-column label="营业执照照片/身份证照片" width="160">
          <template slot-scope="scope">
            <el-image
              style="width: 120px; height: 80px"
              :src="scope.row.license"
              :preview-src-list="srcList"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          prop="agent_company"
          label="所属代理商公司名"
          width="180"
        >
        </el-table-column>
        <el-table-column label="所在地区" width="180">
          <template slot-scope="scope">
            {{ scope.row.province_name }}
            {{ scope.row.city_name }}
            {{ scope.row.district_name }}
          </template>
        </el-table-column>
        <el-table-column prop="vip_start_time" label="账号开始时间" width="140">
        </el-table-column>
        <el-table-column prop="vip_end_time" label="账号结束时间" width="140">
        </el-table-column>
        <el-table-column prop="create_time" label="账号注册时间" width="140">
        </el-table-column>
        <el-table-column label="操作" width="140" fixed="right">
          <template slot-scope="scope">
            <div v-if="!scope.row.is_expire">
              <el-button type="primary" @click="operation(scope.row, 1)"
                >关闭</el-button
              >
            </div>
            <div v-else>
              <el-button type="success" @click="operation(scope.row, 0)"
                >开启</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="current"
        :page-size="15"
        @current-change="current_change"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog title="筛选" :visible.sync="is_dio" width="30%">
      <el-form ref="form" :model="search_data" label-width="100px">
        <el-form-item label="用户帐号">
          <el-input v-model="search_data.username" type="number"></el-input>
        </el-form-item>
        <el-form-item label="公司名称">
          <el-input v-model="search_data.license_company_name"></el-input>
        </el-form-item>
        <el-form-item label="公司所在地区">
          <el-cascader
            v-model="company_city"
            :options="company_options"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="search_data.is_expire">
            <el-option label="开启" :value="0"></el-option>
            <el-option label="关闭" :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            search_data = {};
            company_city = '';
          "
          >清空</el-button
        >
        <el-button @click="is_dio = false">取 消</el-button>
        <el-button type="primary" @click="Submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      loading: false,
      // 筛选是否显示
      is_dio: false,
      // 页码
      page: 0,
      current: 0,
      // 列表
      data_list: [],
      // 大图
      srcList: [],
      //  总数量
      total: 0,
      // 筛选内容
      search_data: {},
      // 筛选地区
      company_city: "",
      company_options: [],
    };
  },
  methods: {
    // 筛选
    Submit() {
      this.loading = true;
      this.current = 0;
      this.page = 0;
      if (this.company_city) {
        this.search_data.city_id = this.company_city[1];
      }
      this.odd_reg_list();
      this.is_dio = false;
    },
    // 翻页
    current_change(val) {
      this.loading = true;
      this.page = val - 1;
      this.odd_reg_list();
    },
    // 获取零工注册列表
    odd_reg_list() {
      require("post", "/hr24_user/v1/odd_reg_list/", {
        page: this.page,
        search_data: this.search_data,
      }).then((res) => {
        if (!res.code) {
          this.total = res.data.register_count;
          this.data_list = res.data.register_list;
          this.data_list.forEach((item) => {
            this.srcList.push(item.license);
          });
          this.loading = false;
        }
      });
    },
    // 操作零工账号
    operation(row, val) {
      this.loading = true;
      require("post", "/hr24_user/v1/close_odd/", {
        user_detail_id: row.user_detail_id,
        is_expire: val,
      }).then((res) => {
        if (!res.code) {
          this.$message.success(res.msg);
          this.odd_reg_list();
        }
      });
    },
    // 地区
    show_place_json() {
      require("post", "/commonality/v1/show_place_json/", { is_add: 1 }).then(
        (res) => {
          if (!res.code) {
            let add = res.data;
            for (let i = 0; i < add.length; i++) {
              for (let j = 0; j < add[i].children.length; j++) {
                delete add[i].children[j]["children"];
              }
            }
            this.company_options = add;
          }
        }
      );
    },
  },
  created() {
    this.loading = true;
    this.odd_reg_list();
    this.show_place_json();
  },
};
</script>

<style scoped>
.pagination /deep/ .el-pagination {
  display: flex;
  justify-content: center;
  margin: 40px 0;
}
.screen {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/user_management/oddJob_resume.vue